import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AppState } from '../../core/app-state';
import { PointDoc } from '../../core/schema/point-schema';
import { PointService } from '../../core/services';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { RxdbPointsEditComponent } from '../rxdb-points-edit/rxdb-points-edit.component';

@Component({
  selector: 'app-rxdb-points-view',
  templateUrl: './rxdb-points-view.component.html',
  styleUrls: ['./rxdb-points-view.component.css']
})
export class RxdbPointsViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  isLoading : boolean = false;
  errorMsg: string = "";
  bSyncing: boolean = false;

  constructor(appState: AppState,
    private pointService : PointService,
    private modalService: BsModalService,
    private router: Router ) {
    super(appState)
  }

  ngOnInit(): void {
    this.pointService.doWhenReady( () => this.loadPoints() )
  }

  ngOnDestroy(): void {
    this.destroy()
    this.pointSubscription?.unsubscribe()
  }

  rxPoints : PointDoc[] = []
  pointSubscription: Subscription;

  async loadPoints() {
    this.errorMsg = ""
    this.rxPoints = []

    this.isLoading = true
    try {
      const pointsSubject =this.pointService.rxCollection.find().$;
      this.pointSubscription?.unsubscribe();
      this.pointSubscription = pointsSubject.subscribe( (points)=>{
        this.rxPoints= points
        this.isLoading=false;
      });
    } catch ( error ) {
      this.errorMsg = this.pointService.extractErrorMsg(error)
    }
  }

  async clearPoints() {
    let initialState = {
      onYes: async () => {
        await this.pointService.rxCollection.remove().then(async () => {
          console.log('rxCollection remove()')
        }).catch(error => {
          console.log('clearPoints() Error: ', error)
        }).finally(() => {
          // location.reload()
          this.router.navigate(['']).then(() => {
            location.reload();
          });
        })
      },
      title: "RxDB Points Rebuild",
      question: `Do you wish to rebuild Point Database?  `
        + `<div class="m-2 small font-italic text-warning"><i class='text-warning fa fa-info-circle mr-1'></i>It may take a few minutes to re-sync Point Data</div>`
        + `<div>Rebuild now?</div>`,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.show(ConfirmModalComponent, {ignoreBackdropClick: true,initialState} );
  }

  editPoints ( pointDoc : PointDoc ) {
    const initialState = {
      point: pointDoc
    }
    this.modalService.show(RxdbPointsEditComponent, {ignoreBackdropClick: true, initialState});
  }

}
